// src/components/DashboardLayout.jsx
// Wraps PortalHeader + an Outlet for nested routes. Each role dashboard
// passes its own nav config; the layout handles the chrome.

import React from "react";
import { Outlet } from "react-router-dom";
import PortalHeader from "./PortalHeader";
import { Receipt, Scan, BarChart3, Ticket, ClipboardList, Link2 } from "./icons";

// floating glyphs behind dashboard content (same tb-float anim as login)
const FLOATERS = [
  { Icon: Receipt, top: "12%", left: "8%", size: 30, dur: "9s", delay: "0s" },
  { Icon: Scan, top: "25%", right: "7%", size: 28, dur: "8s", delay: "1.5s" },
  { Icon: BarChart3, bottom: "18%", left: "10%", size: 32, dur: "7.5s", delay: "0.5s" },
  { Icon: Ticket, bottom: "28%", right: "9%", size: 26, dur: "8.5s", delay: "2s" },
  { Icon: ClipboardList, top: "55%", left: "5%", size: 24, dur: "9.5s", delay: "1s" },
  { Icon: Link2, top: "8%", right: "12%", size: 24, dur: "7s", delay: "2.5s" },
];

export default function DashboardLayout({ nav }) {
  return (
    <div className="relative min-h-screen bg-tb-bg dark:bg-tb-night text-tb-ink dark:text-tb-d-text overflow-hidden">
      {/* ambient background */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-tb-brand/10 blur-3xl" />
        <div className="absolute -bottom-24 -right-20 w-96 h-96 rounded-full bg-tb-brand/10 blur-3xl" />
        {FLOATERS.map(({ Icon, size, top, bottom, left, right, dur, delay }, i) => (
          <div
            key={i}
            className="absolute tb-float text-tb-brand opacity-[0.14] dark:opacity-[0.12]"
            style={{ top, bottom, left, right, animationDuration: dur, animationDelay: delay }}
          >
            <Icon size={size} />
          </div>
        ))}
      </div>
      <div className="relative z-10">
        <PortalHeader nav={nav} />
        <main className="mx-auto max-w-[100rem] px-4 sm:px-6 lg:px-8 py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}